//
export default [
    {
        field: 'discount',
        type: 'readonly',
        value: '',
        vuetifyProps: {
            label: 'Descuento autorizado',
            suffix: '%',
        },
    },
    {
        field: 'sl_ground_seller',
        type: 'readonly',
        maxLength: 100,
        value: '',
        vuetifyProps: {
            label: 'Vendedor asignado',
        },
    },
    {
        field: 'pch_payment_condition_id',
        type: 'readonly',
        maxLength: 100,
        value: '',
        vuetifyProps: {
            label: 'Condición de pago',
        },
    },
    {
        field: 'sl_customer_block',
        type: 'readonly',
        maxLength: 100,
        value: '',
        vuetifyProps: {
            label: 'Estado',
        },
    },

    // {
    //     field: 'phone',
    //     type: 'text',
    //     maxLength: 100,
    //     value: '',
    //     vuetifyProps: {
    //         label: 'Telefono',
    //     },
    // },
    // {
    //     field: 'email',
    //     type: 'text',
    //     maxLength: 100,
    //     value: '',
    //     vuetifyProps: {
    //         label: 'Correo Electrónico',
    //     },
    // },
]
